module.exports = __webpack_public_path__ + "static/khalil-1b49bb709342cf9a09ec28370d414111.png";